/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class WGGameAssets {
    public static INTRO_BACKGROUND: string = "introBackground";

    public static NORMAL_REEL_DIVIDER: string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER: string = "reelDividerNearWin";

    // always playing spine in bg.
    public static MAIN_GAME_BACKGROUND: string = "Animations/bg_fg/bg_sky";
    public static FS_BACKGROUND: string = "Animations/bg_fg/fs_sky";
    public static REEL_BACKGROUND: string = "reelBG";
    public static REEL_BACKGROUND_FS: string = "reelFG";
    public static WIN_AMOUNT_SHADOW: string = "resources/images/WinAmountShadow.png";
    public static BG_LEFT_PILLAR: string = "resources/images/bg_piller_l.png";
    public static BG_RIGHT_PILLAR: string = "resources/images/bg_piller_r.png";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("WGNumbersWinCountUp", "fonts/bitmapfonts/WGNumbersWinCountUp.fnt")
                ]
            }
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json")
                    // new TextureAsset("main9", "sheets/main/main9.json")
                ],
                animations: {
                    //  reel area stuff
                    "reelBG": "Reel/Reel",
                    "reelFG": "Reel/FS_Reel",

                    // dead to alive assets
                    "M1_dead": "MSymbolAliveAnimation/M1/F01_01",
                    "M2_dead": "MSymbolAliveAnimation/M2/F01_01",
                    "M3_dead": "MSymbolAliveAnimation/M3/F01_01",
                    "M4_dead": "MSymbolAliveAnimation/M4/F01_01",
                    "M5_dead": "MSymbolAliveAnimation/M5/F01_01",

                    "M1_alive": "MSymbolAliveAnimation/M1/F01_02",
                    "M2_alive": "MSymbolAliveAnimation/M2/F01_02",
                    "M3_alive": "MSymbolAliveAnimation/M3/F01_02",
                    "M4_alive": "MSymbolAliveAnimation/M4/F01_02",
                    "M5_alive": "MSymbolAliveAnimation/M5/F01_02",

                    // multiplier font
                    "mult_fr_x": "multiplierFont/x",
                    "mult_fr_0": "multiplierFont/0",
                    "mult_fr_1": "multiplierFont/1",
                    "mult_fr_2": "multiplierFont/2",
                    "mult_fr_3": "multiplierFont/3",
                    "mult_fr_4": "multiplierFont/4",
                    "mult_fr_5": "multiplierFont/5",
                    "mult_fr_6": "multiplierFont/6",
                    "mult_fr_7": "multiplierFont/7",
                    "mult_fr_8": "multiplierFont/8",
                    "mult_fr_9": "multiplierFont/9",

                    // betlines
                    "betline_1": "betlines/1",
                    "betline_2": "betlines/2",
                    "betline_3": "betlines/3",
                    "betline_4": "betlines/4",
                    "betline_5": "betlines/5",
                    "betline_6": "betlines/6",
                    "betline_7": "betlines/7",
                    "betline_8": "betlines/8",
                    "betline_9": "betlines/9",

                    //bigWin
                    "LEVEL_0_label": "BigWin/prepare/label",
                    "LEVEL_1_label": "BigWin/hold/label",
                    "LEVEL_2_label": "BigWin/charge/label",
                    "LEVEL_3_label": "BigWin/fight/label",
                    "LEVEL_4_label": "BigWin/gloriousDeath/label",
                    "LEVEL_0_character": "BigWin/prepare/Character",
                    "LEVEL_1_character": "BigWin/hold/Character",
                    "LEVEL_2_character": "BigWin/charge/Character",
                    "LEVEL_3_character": "BigWin/fight/Character",
                    "LEVEL_4_character": "BigWin/gloriousDeath/Character",

                    // bigWin FireParticles
                    "bigWinFireParticle1": "BigWin/fireParticles/fire1",
                    "bigWinFireParticle2": "BigWin/fireParticles/fire2",
                    "bigWinFireParticle3": "BigWin/fireParticles/fire3",
                    "bigWinFireParticle4": "BigWin/fireParticles/fire4",

                    // sticky lock stuff
                    "wild_reel_loock_Animation": "Animations/wild_lock/wild_chain/wild_chain_",
                    "wild_reel_lock_Cage": "Animations/wild_lock/wild_lock_frame",
                    "wild_shine": "Animations/wild_lock/lock_overlay_half size",

                    // pillars top part and fire
                    "freeGameLeftPillar": "Reel/fs_piller_l",
                    "freeGameRightPillar": "Reel/fs_piller_r",
                    "pillar_fire_Animation": "PillarsFireLoop/fire_loop_",

                    // super fs aniticipation
                    "superFsBorder": "light_side/light_side",
                    // underground stuff
                    "undergroundTransition": "Intro/UndergroundTransitionHalfSize",

                    // warrior moving left stuff
                    "warriorTopAndBottomPuff": "dust_animation/dust_puff/dust_puff_",
                    "warriorSmoke": "dust_animation/smoke",
                    "warriorHitFire": "dust_animation/hit_fire",

                    // warrior Attack anticipation
                    "WarriorAttackAnticipation_Blast": "WarriorAttackAnticipation/blast/blast_",
                    "WarriorAttackAnticipation_colorPatch": "WarriorAttackAnticipation/color_patch",

                    "WarriorAttackText": "WarriorAttack_text"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                    new TextureAsset("mainJpeg16", "sheets/mainJpeg/mainJpeg16.json"),
                    new TextureAsset("mainJpeg17", "sheets/mainJpeg/mainJpeg17.json"),
                    new TextureAsset("mainJpeg18", "sheets/mainJpeg/mainJpeg18.json")
                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "fsBackground": "fsBackground",
                    "winBox": "winBox/winBox_",

                    "introBackground": "Animations/Intro_outro/Intro_Bg",
                    "outroBackground": "Animations/Intro_outro/Outro_Bg",

                    // scatter anticipation animation
                    "scatterAnticipationLoop": "anticipation/S_anticipation/anti_loop/anti_loop_",
                    "scatterAnticipationBase": "anticipation/S_anticipation/anti_base/anti_base_",
                    "scatterAnticipationStrike": "anticipation/S_anticipation/anti_strike/anti_strike_",

                    // super fs aniticipation
                    "superFsSideParticles": "anticipation/particles_side/particles_side_",
                    "superFsSideTopBottomFire": "anticipation/top_bottom_fire/top_bottom_fire_",

                    // warrior anticipation animation
                    "warriorAnticipationTopRing": "anticipation/W_anticipation/w_top_bottom_ring/T_B_ring_",
                    "warriorAnticipationLoop": "anticipation/W_anticipation/w_anti_loop/w_anti_loop_",
                    "warriorAnticipationStrike": "anticipation/W_anticipation/w_anti_strike/w_anti_strike_",

                    // warrior moving left stuff
                    "warriorSlamParticles": "warriorParticles/particles_",

                    // warrior attack anticipation
                    "WarriorAttackAnticipation_frameFire": "WarriorAttackAnticipation/frame_fire/frame_fire_",

                    //
                    "wildMultiplierGlow": "symMultiplier/symMultiplier_",
                    "mid_stack_idle_half": "Dead_idle_generic/Dead_idle_generic_",
                    "bigWinFire": "BWFire/BW_Fire_",

                    // fs energy ball
                    "energyBall": "energy_ball/energy_ball1"
                }
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("fs_mult_meter", "Spine/fs_mult_meter.json"),
                    new SpineAsset("winbox", "Spine/winbox.json"),
                    new SpineAsset("s", "Spine/Scatter.json"),
                    new SpineAsset("l1", "Spine/l1.json"),
                    new SpineAsset("l2", "Spine/l2.json"),
                    new SpineAsset("l3", "Spine/l3.json"),
                    new SpineAsset("l4", "Spine/l4.json"),
                    new SpineAsset("l5", "Spine/l5.json"),
                    new SpineAsset("intro_outro_spine", "Spine/intro_outro.json"),
                    new SpineAsset("wild_stack", "Spine/wild.json"),
                    new SpineAsset("baseGameIdleAnimation", "Spine/bg_idle.json"),
                    new SpineAsset("freeGameIdleAnimation", "Spine/fg_idle.json"),
                    new SpineAsset("plusone_freespin", "Spine/plusone_freespin.json"),
                    new SpineAsset("superFresspinsIdleAnimation", "Spine/sfs_idle.json"),
                    new SpineAsset("bigwinExplosion", "Spine/bigwin_explosion.json"),
                    new SpineAsset("midSymbolTransition", "Spine/mid_transition.json"),
                    new SpineAsset("m1_alive_win", "Spine/m1_alive_win.json"),
                    new SpineAsset("m2_alive_win", "Spine/m2_alive_win.json"),
                    new SpineAsset("m3_alive_win", "Spine/M3_alive_win.json"),
                    new SpineAsset("m4_alive_win", "Spine/m4_alive_win.json"),
                    new SpineAsset("m5_alive_win", "Spine/m5_alive_win.json"),
                    new SpineAsset("fs_wild_landing", "Spine/fs_wild_landing.json")
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                ],
                animations: {

                    // fs intro tesxts
                    "freeSpinText_8": "Intro/8_Number",
                    "freeSpinText_10": "Intro/10_Number",
                    "freeSpinText_12": "Intro/12_Number",
                    "freeSpinText_14": "Intro/14_Number",
                    "graveyardSpinsText": "Intro/Graveyard_Spins_Text",
                    "deathSpinsText": "Intro/DeathSpinsText",
                }
            },
            {
                name: "blurSymbols",
                assets: [
                    new TextureAsset("blurSymbols0", "sheets/blurSymbols/blurSymbols0.json"),
                ]
            }, {
                name: "bigWin",
                assets: [
                    new TextureAsset("bigWin0", "sheets/bigWin/bigWin0.json"),
                ],
                animations: {
                    //bigWin
                    "LEVEL_0_label": "prepare/label",
                    "LEVEL_1_label": "hold/label",
                    "LEVEL_2_label": "charge/label",
                    "LEVEL_3_label": "fight/label",
                    "LEVEL_4_label": "gloriousDeath/label",
                    "LEVEL_0_character": "prepare/Character",
                    "LEVEL_1_character": "hold/Character",
                    "LEVEL_2_character": "charge/Character",
                    "LEVEL_3_character": "fight/Character",
                    "LEVEL_4_character": "gloriousDeath/Character",
                }
            }
        ]
    };
}
